import { render } from "./IsoGrowFooter.vue?vue&type=template&id=14682a1c&scoped=true"
import script from "./IsoGrowFooter.vue?vue&type=script&lang=js"
export * from "./IsoGrowFooter.vue?vue&type=script&lang=js"

import "./IsoGrowFooter.vue?vue&type=style&index=0&id=14682a1c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14682a1c"]])

export default __exports__